export const paths = {
  index: '/',
  about: {
    index: '/about',
    teamMember: '/about/team/:slug'
  },
  projects: {
    index: '/projects',
    caseStudies: '/projects/case-studies'
  },
  checkout: '/checkout',
  contact: '/contact',
  saas: '/saas',
  support: '/support',
  privacyPolicy: '/privacy-policy',
  refundPolicy: '/refund-policy',
  eula: '/eula',
  blog: {
    index: '/blog',
    post: '/blog/:slug'
  },
  schedule: '/schedule',
  services: {
    branding: '/services/branding',
    websites: '/services/websites',
    marketing: '/services/marketing',
    googleBusinessProfile: '/services/google-business-profile-optimization',
    adBuying: '/services/ad-buying',
    content: '/services/content',
    aiAutomation: '/services/ai-automation'
  },
  auth: {
    auth0: {
      callback: '/auth/auth0/callback',
      login: '/auth/auth0/login'
    },
    jwt: {
      login: '/auth/jwt/login',
      register: '/auth/jwt/register'
    },
    firebase: {
      login: '/auth/firebase/login',
      register: '/auth/firebase/register'
    },
    amplify: {
      confirmRegister: '/auth/amplify/confirm-register',
      forgotPassword: '/auth/amplify/forgot-password',
      login: '/auth/amplify/login',
      register: '/auth/amplify/register',
      resetPassword: '/auth/amplify/reset-password'
    }
  },
  authDemo: {
    forgotPassword: {
      classic: '/auth-demo/forgot-password/classic',
      modern: '/auth-demo/forgot-password/modern'
    },
    login: {
      classic: '/auth-demo/login/classic',
      modern: '/auth-demo/login/modern'
    },
    register: {
      classic: '/auth-demo/register/classic',
      modern: '/auth-demo/register/modern'
    },
    resetPassword: {
      classic: '/auth-demo/reset-password/classic',
      modern: '/auth-demo/reset-password/modern'
    },
    verifyCode: {
      classic: '/auth-demo/verify-code/classic',
      modern: '/auth-demo/verify-code/modern'
    }
  },
  dashboard: {
    index: '/dashboard',
    insights: '/dashboard/insights',
    salesDashboard: '/dashboard/sales-dashboard',
    salesPipeline: '/dashboard/sales-pipeline',
    training: '/dashboard/training',
    account: '/dashboard/account',
    analytics: '/dashboard/analytics',
    blank: '/dashboard/blank',
    blog: {
      index: '/dashboard/blog',
      postDetails: '/dashboard/blog/:postId',
      postCreate: '/dashboard/blog/create'
    },
    calendar: '/dashboard/calendar',
    imageUrlTool: '/dashboard/image-url-tool',
    downloads: '/dashboard/downloads',
    chat: '/dashboard/chat',
    create: '/dashboard/create',
    documents: '/dashboard/documents',
    crm: {
      index: '/dashboard/create-email/quote',
      invoice: '/dashboard/invoice',
      update: '/dashboard/create-email/update'
    },
    webInvoice: '/dashboard/invoice',
    webQuote: '/dashboard/quote',
    sendEmail: '/dashboard/send-email',
    inbox: '/dashboard/inbox',
    supportHub: '/dashboard/support-hub',
    enrichment: '/dashboard/enrichment',
    exhaustLead: {
      index: '/dashboard/exhaust-lead'
    },
    exhaustOldLead: {
      index: '/dashboard/exhaust-old-lead'
    },
    salesTraining: '/dashboard/sales-training',
    salesPresentation: '/dashboard/sales-presentation',
    salesScripts: '/dashboard/sales-scripts',
    sendTexts: '/dashboard/send-texts',
    tasks: '/dashboard/tasks',
    workflows: '/dashboard/workflows',
    customers: {
      index: '/dashboard/customers',
      paid: '/dashboard/customers/paid',
      '2025Leads': '/dashboard/customers/2025-leads',
      '2026Leads': '/dashboard/customers/2026-leads',
      import: '/dashboard/customers/import',
      create: '/dashboard/customers/create',
      details: '/dashboard/customers/:customerId',
      edit: '/dashboard/customers/:customerId/edit'
    },
    ecommerce: '/dashboard/ecommerce',
    fileManager: '/dashboard/file-manager',
    cloud: '/dashboard/cloud',
    inventory: '/dashboard/inventory',
    reports: '/dashboard/reports',
    logs: '/dashboard/logs',
    contractors: '/dashboard/contractors',
    companyContracts: '/dashboard/contracts',
    company: {
      index: '/dashboard/company',
      team: '/dashboard/company/team',
      files: '/dashboard/company/files',
    },
    sheet: '/dashboard/sheet',
    recordingTool: '/dashboard/recording-tool',
    salesRecordings: '/dashboard/sales-recordings',
    customQuote: '/dashboard/custom-quote',
    quotes: {
      index: '/dashboard/quotes',
      create: '/dashboard/custom-quote',
      list: '/dashboard/quotes/list'
    },
    giftcard: '/dashboard/giftcard',
    quickbooks: '/dashboard/quickbooks',
    tools: '/dashboard/tools',
    marketing: {
      campaigns: '/dashboard/marketing/campaigns',
      analytics: '/dashboard/marketing/analytics',
      socialMedia: '/dashboard/marketing/social-media'
    },
    invoices: {
      index: '/dashboard/invoices',
      list: '/dashboard/lead-invoices',
      details: '/dashboard/lead-invoices/:invoiceId'
    },
    jobs: {
      index: '/dashboard/jobs',
      create: '/dashboard/jobs/create',
      companies: {
        details: '/dashboard/jobs/companies/:companyId'
      }
    },
    kanban: '/dashboard/kanban',
    mail: '/dashboard/mail',
    orders: {
      index: '/dashboard/orders',
      details: '/dashboard/orders/:orderId'
    },
    products: {
      index: '/dashboard/products',
      create: '/dashboard/products/create'
    },
    social: {
      index: '/dashboard/social',
      profile: '/dashboard/social/profile',
      feed: '/dashboard/social/feed'
    },
    signedAgreements: '/dashboard/signed-agreements',
    testimonials: '/dashboard/testimonials',
    make: {
      index: '/dashboard/make',
      scenario: (scenarioId: number | string) => `/dashboard/make/${scenarioId}`,
    },
    zapier: '/dashboard/zapier',
    n8n: '/dashboard/n8n',
    accounting: {
      index: '/dashboard/accounting',
      revenue: '/dashboard/accounting/revenue',
      expenses: '/dashboard/accounting/expenses',
      payroll: '/dashboard/accounting/payroll',
      reports: '/dashboard/accounting/reports',
    },
    atlas: '/dashboard/atlas',
    leadGeneration: '/dashboard/lead-generation',
    databaseMoat: '/dashboard/database-moat',
    knowledgeBase: '/dashboard/knowledge-base',
    coldProspecting: '/dashboard/cold-prospecting',
    elevenlabs: '/dashboard/elevenlabs',
    settings: '/dashboard/settings',
    // Andrea
    andrea: {
      chat: '/dashboard/andrea/chat',
      callLog: '/dashboard/andrea/call-log',
      messageLog: '/dashboard/andrea/message-log',
      config: '/dashboard/andrea/config',
    },
    // Control
    control: {
      overview: '/dashboard/control/overview',
      channels: '/dashboard/control/channels',
      instances: '/dashboard/control/instances',
      sessions: '/dashboard/control/sessions',
      cronJobs: '/dashboard/control/cron-jobs',
      memory: '/dashboard/control/memory',
    },
    // Agent Settings
    agentSettings: {
      config: '/dashboard/agent-settings/config',
      debug: '/dashboard/agent-settings/debug',
      logs: '/dashboard/agent-settings/logs',
    },
  },
  components: {
    index: '/components',
    dataDisplay: {
      detailLists: '/components/data-display/detail-lists',
      tables: '/components/data-display/tables',
      quickStats: '/components/data-display/quick-stats'
    },
    lists: {
      groupedLists: '/components/lists/grouped-lists',
      gridLists: '/components/lists/grid-lists'
    },
    forms: '/components/forms',
    modals: '/components/modals',
    charts: '/components/charts',
    buttons: '/components/buttons',
    typography: '/components/typography',
    colors: '/components/colors',
    inputs: '/components/inputs'
  },
  docs: '',
  401: '/401',
  404: '/404',
  500: '/500'
};
